import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { type ReactNode } from "react";

interface QueryProviderProps {
  children: ReactNode;
}

/**
 * Module-level QueryClient singleton.
 * Exported so that code outside the React tree (e.g. App.tsx account-switch handler)
 * can call queryClient.clear() without needing useQueryClient().
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export function QueryProvider({ children }: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}

